import React from 'react';
import { Helmet } from 'react-helmet-async';
import Header from '../components/Header';
import Footer from '../components/Footer';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Helmet>
        <title>Privacy Policy - asdflo</title>
        <meta name="description" content="Learn how asdflo protects your privacy and handles your personal information." />
      </Helmet>
      
      <Header />
      
      <main className="flex-grow bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <div className="bg-white shadow overflow-hidden sm:rounded-lg">
            <div className="px-4 py-5 sm:px-6">
              <h1 className="text-3xl font-bold text-gray-900">Privacy Policy</h1>
              <p className="mt-1 max-w-2xl text-sm text-gray-500">Last updated: July 28, 2024</p>
            </div>
            <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
              <div className="prose max-w-none px-6 py-4 sm:px-6">
                <p className="text-gray-700 mb-4">
                  Asdflo Innovations OPC Pvt Ltd respects your privacy. We collect personal information (like name, contact number, email, etc.) only to deliver therapy, consultation, and platform-related services.
                </p>
                <p className="text-gray-700 mb-4">
                  We never share data with third parties, except as required by law or to process payments.
                </p>
                <p className="text-gray-700 mb-4">
                  All video sessions and therapist interactions are encrypted and stored securely if recorded.
                </p>
                <p className="text-gray-700">
                  For any concerns, contact us at: <a href="mailto:info@asdflo.com" className="text-blue-600 hover:underline">info@asdflo.com</a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
